import { errorHandlingInterceptor } from "@core/api/interceptors/error-handling-interceptor";
import { addResponseInterceptor } from "@core/api/interceptors/interceptor";
import { localeKeysToIntlLocale } from "@core/i18n/locale-helper";
import { Wordings } from "@core/i18n/translations-manager";
import { ServerConfigManager } from "@domain/server-config/server-config-manager";
import { AxiosInstance } from "axios";
import { WeekdaysConfig } from "@core/i18n/translations-manager";
import { ApiService } from "@core/api/api-service";
import { isApiError } from "@core/api/api-error";
import { TranslationsAlreadyUpToDateError } from "@core/i18n/translations-errors";

export class TranslationsService {
	axiosInstance: AxiosInstance;

	constructor(
		private readonly axiosInstanceProvider: () => AxiosInstance,
		private readonly serverConfigService: ServerConfigManager,
		private readonly apiService: ApiService,
	) {
		this.axiosInstance = this.initiateAxiosInstance();
	}

	private initiateAxiosInstance(): AxiosInstance {
		const axiosInstance = this.axiosInstanceProvider();
		addResponseInterceptor(axiosInstance, errorHandlingInterceptor());
		return axiosInstance;
	}

	async fetchWordings(lastUpdateDate: string): Promise<{ translations: Wordings; versionDate: string }> {
		try {
			const serverConfig = this.serverConfigService.serverConfig;
			const result = await this.axiosInstance.get<Wordings>(serverConfig.translations.url, {
				headers: { "if-modified-since": lastUpdateDate },
			});
			return { translations: localeKeysToIntlLocale(result.data), versionDate: result.headers["last-modified"] };
		} catch (e) {
			if (isApiError(e) && e.status === 304) {
				throw new TranslationsAlreadyUpToDateError(e.message);
			}
			throw e;
		}
	}

	async fetchWeekdaysConfig(): Promise<WeekdaysConfig> {
		const result = await this.apiService.get<WeekdaysConfig>("/localization/weekdays-config");
		return result.data;
	}
}
